module.exports = __webpack_public_path__ + "static/media/notifications.dcf5523c.svg";